export type Image = {
  ImageId: string,
  DisplayOrder: number,
  LastModified: Date,
  FileName: string,
  ImageUrl: string,
  Thumbnail: string,
  HighResolution: string,
  Blob: string,
  IsChecked: boolean
};

export enum ImageType {
  WebReady = 1,
  HighResolution = 2
};
